import { api } from "@/features/auth/api";

export type WalletSummary = {
    user_id: string;
    balance: number;
    status: "active" | "frozen";
    updated_at?: string | null;
    whatsapp_number?: string;
};

export type WalletTxn = {
    id: string;
    kind: "credit" | "debit";
    amount: number;
    reason: string;
    reference: string;
    balance_after: number;
    source: string;
    order_id: string | null;
    actor_email: string;
    actor_role: string;
    at: string;
};

export const walletApi = {
    summary: async () => (await api.get<WalletSummary>("/wallet/summary")).data,
    transactions: async (page = 1, page_size = 25) =>
        (
            await api.get<{ items: WalletTxn[]; total: number }>(
                "/wallet/transactions",
                { params: { page, page_size } },
            )
        ).data,
    adminGet: async (userId: string) =>
        (
            await api.get<{
                customer: { id: string; email: string; full_name: string; phone: string };
                wallet: WalletSummary;
            }>(`/admin/wallet/${userId}`)
        ).data,
    adminTransactions: async (userId: string, page = 1, page_size = 25) =>
        (
            await api.get<{ items: WalletTxn[]; total: number }>(
                `/admin/wallet/${userId}/transactions`,
                { params: { page, page_size } },
            )
        ).data,
    adminCredit: async (userId: string, amount: number, reason: string) =>
        (await api.post<WalletTxn>(`/admin/wallet/${userId}/credit`, { amount, reason })).data,
    adminDebit: async (userId: string, amount: number, reason: string) =>
        (await api.post<WalletTxn>(`/admin/wallet/${userId}/debit`, { amount, reason })).data,
    adminUpdateWhatsapp: async (whatsapp_number: string) =>
        (
            await api.put<{ whatsapp_number: string }>("/admin/wallet/settings", {
                whatsapp_number,
            })
        ).data,
};
